module.exports = __webpack_public_path__ + "723494a4.png";